import React, {useState,useEffect} from "react";
import CircularProgress from '@mui/material/CircularProgress';
import {axiosInstance} from "../../config/apiTemplate";
import { DataGridPro,GridToolbarContainer,GridToolbarColumnsButton,GridToolbarFilterButton,GridToolbarExport,GridToolbarDensitySelector, GridOverlay,GridToolbar } from "@mui/x-data-grid-pro";
import LinearProgress  from "@mui/material/LinearProgress";
import { renderDate, formatToDateObj } from "../shared/util";
export default function CashDivLog(props){

    const [logs,setLogs] = useState([]);
    const [response, setResponse] = useState({});
    const [isLoading, setLoading] = useState(true);

    useEffect(()=>{
        document.title = "ETSW - Cash Dividends Logs";
        setLoading(true);
        getLogs();

        return () =>{
            setLoading(false);  
        }
    },[props.trading_id,props.ts]);


    async function getLogs(){
        let headerForm = new FormData();
  
        const url = "client_api/logs/getCashDividends.php";
    
        try {
          const response = await axiosInstance.post(url, headerForm);
          if (response.data.status === 201) {
            let logs = response.data.cash_dividends.table;
            logs = logs.map((item,index)=>{
                return {...item,no:(index+1),id:index};
            });
            let resp = response.data.cash_dividends.header;
            setLogs(logs);
            setResponse(resp);
          }
         setLoading(false);
        } catch (e) {
          console.log(e);
          setLoading(false);
        }
    }

    function renderLoading(){
        return(
            <div className="text-center">
                <CircularProgress />
                <p>Fetching Data...</p>
            </div>
        )
    }

      function renderCustomToolbar(){
        return (
            <GridToolbarContainer>
                <GridToolbarColumnsButton />
                <GridToolbarFilterButton />
                <GridToolbarDensitySelector />
                <GridToolbarExport />
            </GridToolbarContainer>
        );
    }

    function renderNoRows(){
        return(
            <GridOverlay>
                <div>
                    <h6 style={{fontStyle:"italic"}}>No Transactions....</h6>
                </div>
            </GridOverlay>
        )
    }

    function loadingOverlay(){
        return(
            <GridOverlay>
                <div style={{ position: 'absolute', top: 0, width: '100%' }}>
                <LinearProgress />
                </div>
            </GridOverlay>
        )
    }


    function renderBoldText(props){
        if(props.field === "div_amt" || props.field === "taxes" || props.field === "div_per_share" ){
            return(
                <span className="boldText" style={{fontSize:18,width:"100%"}}>RM {props.value}</span>
            );
        }else{
            return(
                <span className="boldText" style={{fontSize:18,width:"100%"}}>{props.value}</span>
            );
        }
    }

    return(
        <div className="container-fluid pt-3">
            <div className="row">
                <div className="col">
                    <div style={{minHeight:"65vh",display:"flex"}}>
                        <div style={{ flexGrow: 1, backgroundColor: "white", marginTop: 20 }}>
                        <DataGridPro
                            density="compact"
                            loading={isLoading}
                            columns={[
                            {
                                field: "no",
                                headerName: "No.",
                                flex: 1,
                            },
                            {
                                field: "payment_date",
                                headerName: "Payment Date",
                                minWidth: 120,
                                flex: 2,
                                type:"date",
                                renderCell:renderDate,
                                valueGetter:({value})=>value && formatToDateObj(value)
                            },
                            {
                                field: "ex_date",
                                headerName: "Ex Date",
                                minWidth: 120,
                                flex: 2,
                                type:"date",
                                renderCell:renderDate,
                                valueGetter:({value})=>value && formatToDateObj(value)
                            },
                            {
                                field: "klsename",
                                headerName: "Stock Name",
                                minWidth: 120,
                                flex: 2,
                                renderCell:renderBoldText
                            },
                            // {
                            //     field: "quantity",
                            //     headerName: "Quantity of Shares",
                            //     minWidth: 140,
                            //     flex: 2,
                            //     renderCell:renderBoldText
                            // },
                            {
                                field: "description",
                                headerName: "Dividend Description",
                                minWidth: 100,
                                flex: 2,
                                renderCell:renderBoldText
                            },
                            {
                                field: "div_amt",
                                headerName: "Net Dividend Amount",
                                minWidth: 140,
                                flex: 2,
                                renderCell:renderBoldText
                            },
                            ]}
                            pagination
                            rows={logs}
                            components={{
                                Toolbar: GridToolbar,
                                LoadingOverlay: loadingOverlay,
                                NoRowsOverlay: renderNoRows
                            }}
                            componentsProps={{
                                toolbar: {
                                  showQuickFilter: true,
                                  quickFilterProps: { debounceMs: 500 },
                                },
                            }}
                        />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );


}